import store from '@/store';
import { RouteLocationNormalized, RouteLocationRaw } from 'vue-router';

export const PUBLIC_ROUTE_NAMES = new Set([
  'sign-in',
  'sign-up',
  'password-reset',
  '401',
  '403',
  '404',
  '500',
]);

export const isAuthenticated = (): boolean => {
  return store.getters.isUserAuthenticated;
};

export const authGuard = (
  to: RouteLocationNormalized,
): RouteLocationRaw | undefined => {
  if (to.name === 'sign-in' && isAuthenticated()) {
    return { name: 'dashboard' };
  }

  const routeName = to.name as string | undefined;
  const isPublicRoute = routeName ? PUBLIC_ROUTE_NAMES.has(routeName) : false;

  if (!isPublicRoute && !isAuthenticated()) {
    return { name: 'sign-in' };
  }
};
